<template>
  <el-row>
    <el-card shadow="none"
             class="form-card mb-15">
      <el-form :inline="true"
               :model="searchForm"
               ref="search_form"
               class="search-form">
        <el-form-item label="模块名称:"
                      prop="name">
          <el-input v-model.trim="searchForm.name"
                    placeholder="模块名称"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary"
                     icon="el-icon-search"
                     @click="searchSubmit('search_form')">查询</el-button>
          <el-button icon="el-icon-refresh"
                     @click="resetForm('search_form')">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>
    <el-row>
      <el-button v-has="''"
                 type="primary"
                 @click="handleAdd(1)">新增</el-button>
    </el-row>
    <el-card shadow="none"
             class="mt-15">
      <el-table max-height="520"
                :data="tableData"
                style="width: 100%;margin-bottom: 20px;"
                row-key="id"
                default-expand-all
                :tree-props="{ children: 'children', hasChildren: 'hasChildren' }">
        <el-table-column fixed="left"
                         type="index"
                         label="序号"
                         width="60">
        </el-table-column>
        <el-table-column v-for="(item, index) in tableTitle"
                         :key="index"
                         :fixed="item.fixed"
                         :label="item.name"
                         :prop="item.prop"
                         :min-width="item.width"
                         :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column fixed="right"
                         label="操作"
                         width="230">
          <template slot-scope="scope">
            <el-button v-has="'/permission/add'"
                       v-if="scope.row.perm_type !== 'perm_type_button'"
                       size="mini"
                       type="success"
                       @click="handleAdd(2, scope.row)">新增</el-button>
            <el-button v-has="'/permission/edit'"
                       size="mini"
                       type="primary"
                       @click="handleEdit(scope.row)">编辑</el-button>
            <el-button v-has="'/permission/del'"
                       size="mini"
                       type="danger"
                       @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <add-menu v-if="showMenuModal"
              :isShow="showMenuModal"
              :data="menuData"
              @handleClose="closeMenuModal"></add-menu>
  </el-row>
</template>

<script>
import fetch from '@/common/api'
import AddMenu from '@/views/system/menu/AddMenu'
export default {
  components: { AddMenu },
  data() {
    return {
      searchModule: [],
      searchForm: {
        name: ''
      },
      tableTitle: [
        {
          prop: 'name',
          name: '模块名称',
          fixed: 'left',
          width: '120'
        },
        {
          prop: 'sort',
          name: '权重',
          width: '80'
        },
        {
          prop: 'uri',
          name: '地址',
          width: '120'
        },
        {
          prop: 'icon',
          name: '图标',
          width: '80'
        }
      ],
      tableData: [],
      // 分页相关
      pagination: {
        total: 0,
        currentPage: 1,
        perPage: 3
      },
      // 选中数据
      multipleSelection: [],
      selectLen: 0,
      selectId: '',
      // 添加菜单相关
      showMenuModal: false,
      menuData: {
        type: 'add'
      }
    }
  },
  computed: {
    getExpand() {
      return function (val) {
        return this.expandId === val && this.isExpand
      }
    }
  },
  created() {
    this.getList()
  },
  methods: {
    // 获取列表
    getList() {
      fetch.getMenuTreeList({ ...this.searchForm }).then((data) => {
        data.procData(
          data.res,
          (data) => {
            this.tableData = data.treeData
          },
          (err) => {
            this.$message.error(err)
          }
        )
      })
    },
    // 搜索提交
    searchSubmit() {
      this.pagination.perPage = 10
      this.pagination.currentPage = 1
      this.getList()
    },
    resetForm(formName) {
      this.pagination.perPage = 10
      this.pagination.currentPage = 1
      this.$refs[formName].resetFields()
      this.getList()
    },
    // 添加模块
    handleAdd(type, data) {
      this.showMenuModal = true
      this.menuData = {
        type: 'add',
        id: type === 2 ? data.id : ''
      }
    },
    // 关闭添加模块弹窗
    closeMenuModal(type) {
      if (type === 'refresh') {
        this.getList()
      }
      this.showMenuModal = false
    },
    // 编辑
    handleEdit(data) {
      this.showMenuModal = true
      this.menuData = {
        type: 'edit',
        id: data.id
      }
    },
    // 删除
    handleDelete(datas) {
      this.$confirm('是否确定删除该条数据?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          fetch.delMenu({ id: datas.id }).then((data) => {
            data.procData(
              data.res,
              () => {
                this.getList()
                this.$message.success('操作成功')
                this.$store.commit('freshMenu', { flag: true })
              },
              (err) => {
                this.$message.error(err)
              }
            )
          })
        })
        .catch(() => {})
    }
  }
}
</script>

<style lang="less" scoped></style>
